'use client'

import { useEffect, useRef, useState } from 'react'

import { createDefinitionLoader, type PanelState } from './load-definition'
import { handleGlossaryClick, handleGlossaryToggle, type PanelController } from './panel-events'

export const useGlossaryPanel = () => {
  const panelRef = useRef<HTMLDivElement>(null)
  const closeRef = useRef<HTMLButtonElement>(null)
  const [state, setState] = useState<PanelState | null>(null)

  useEffect(() => {
    const panel = panelRef.current
    const scope = panel?.closest('[data-glossary-scope]')
    if (!panel || !scope || typeof panel.showPopover !== 'function') {
      return
    }
    const controller: PanelController = {
      panel,
      scope,
      closeButton: closeRef.current,
      trigger: null,
      ...createDefinitionLoader(setState),
    }
    const click = (event: Event) => handleGlossaryClick(event, controller)
    const toggle = (event: Event) => handleGlossaryToggle(event, controller)
    scope.addEventListener('click', click)
    panel.addEventListener('toggle', toggle)
    return () => {
      controller.abort()
      scope.removeEventListener('click', click)
      panel.removeEventListener('toggle', toggle)
      controller.trigger?.removeAttribute('aria-expanded')
      controller.trigger?.removeAttribute('aria-controls')
    }
  }, [])

  return { panelRef, closeRef, state }
}
